import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { initialFilterState as applicantsFilterState } from "../pages/Applicants/index";
import { initialFilterState as employeesFilterState } from "../pages/Employees/index";
import { initialFilterState as coursesFilterState } from "../pages/Training/Courses/index";
import { initialFilterState as participantsFilterState } from "../pages/Training/Participants/index";
import { initialFilterState as certificationsFilterState } from "../pages/Training/Certifications/index";
import { AMSModules } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
	PATH_APPLICANTS,
	PATH_EMPLOYEE,
	PATH_TRAINING_CERTIFICATIONS,
	PATH_TRAINING_COURSES,
	PATH_TRAINING_PARTICIPANTS,
} from "../utils/routeConstants";

const useStyles = makeStyles((theme) => ({
	table: {
		borderRadius: 6,
		"& th": {
			backgroundColor: theme.palette.mode === "dark" ? "#1E2E3A !important" : "#d3d3d3 !important",
		},
	},
}));

export const CountTable = ({
	data,
	label,
	module = null,
	participantList = [],
	showHours = false,
	autoHeight = false,
}) => {
	const unknown = "N/A";
	const classes = useStyles();
	const history = useHistory();
	const dispatch = useDispatch();
	const {
		codePerApplicantStatus,
		codePerDepartment,
		codePerSection,
		codePerRank,
		codePerTitlePosition,
	} = useSelector((state) => state.dictionary.dictionary);

	const getCodeFromDictionary = (data, key) => {
		const codeInfo = data?.find(
			(item) =>
				item?.Description?.toLowerCase()?.trim() ===
				key?.toLowerCase()?.trim(),
		);
		if (!codeInfo) return [];
		const code = {
			label: codeInfo?.Description,
			value: codeInfo?.Code,
			code: codeInfo?.Code,
			description: codeInfo?.Description,
			isDefault: codeInfo?.IsDefault,
		};
		return [code];
	};

	const getEmployeeNumber = (key) => {
		if (participantList.length === 0) return "";
		const participant = participantList.find(
			(p) =>
				`${p.employeeDetails.firstName || ""} ${
					p.employeeDetails.middleName || ""
				} ${p.employeeDetails.lastName || ""}`.trim() === key,
		);
		return participant
			? [
					{
						label: `${participant.employeeNum} - ${participant.lastName}, ${participant.firstName}`,
						value: participant.employeeNum,
					},
				]
			: [];
	};

	const handleNavigation = (e, key) => {
		e.preventDefault();
		e.stopPropagation();

		// Applicants
		if (module === AMSModules.Applicants) {
			dispatch({
				type: AMSModules.Applicants,
				payload: !(key === unknown)
					? {
							...applicantsFilterState,
							status: getCodeFromDictionary(
								codePerApplicantStatus,
								key,
							),
						}
					: applicantsFilterState,
			});
			history.push(PATH_APPLICANTS);
		}

		// Employees
		if (module === AMSModules.Employees) {
			const filterPayload = !(key === unknown)
				? {
						...employeesFilterState,
						department:
							label === "Department"
								? getCodeFromDictionary(codePerDepartment, key)
								: [],
						section:
							label === "Section"
								? getCodeFromDictionary(codePerSection, key)
								: [],
						rank:
							label === "Rank"
								? getCodeFromDictionary(codePerRank, key)
								: [],
						titlePosition:
							label === "Title"
								? getCodeFromDictionary(
										codePerTitlePosition,
										key,
									)
								: [],
					}
				: employeesFilterState;

			dispatch({
				type: AMSModules.Employees,
				payload: filterPayload,
			});
			history.push(PATH_EMPLOYEE);
		}

		// Courses
		if (module === AMSModules.Courses) {
			const filterPayload = !(key === unknown)
				? {
						...coursesFilterState,
						category:
							label === "Category"
								? { label: key?.trim(), value: key?.trim() }
								: "",
						courseName: label === "Course Name" ? key?.trim() : "",
					}
				: coursesFilterState;

			dispatch({
				type: AMSModules.Courses,
				payload: filterPayload,
			});
			history.push(PATH_TRAINING_COURSES);
		}

		// Participants
		if (module === AMSModules.Participants) {
			const filterPayload = !(key === unknown)
				? {
						...participantsFilterState,
						employeeNum: getEmployeeNumber(key?.trim()) || "",
					}
				: participantsFilterState;
			dispatch({
				type: AMSModules.Participants,
				payload: filterPayload,
			});
			history.push(PATH_TRAINING_PARTICIPANTS);
		}

		// Certifications
		if (module === AMSModules.Certifications) {
			const filterPayload = !(key === unknown)
				? {
						...certificationsFilterState,
						certificationType:
							{ label: key?.trim(), value: key?.trim() } || "",
					}
				: certificationsFilterState;
			dispatch({
				type: AMSModules.Certifications,
				payload: filterPayload,
			});
			history.push(PATH_TRAINING_CERTIFICATIONS);
		}
	};

	return (
		<TableContainer
			component={Paper}
			sx={{
				maxHeight: autoHeight ? "auto" : 120,
				overflowY: autoHeight ? "visible" : "auto",
				mt: 1,
				mb: 1,
			}}
		>
			<Table size="small" className={classes.table}>
				<TableHead>
					<TableRow>
						<TableCell sx={{ fontWeight: "bold" }}>
							{label}
						</TableCell>
						<TableCell
							sx={{
								fontWeight: "bold",
								width: 100,
							}}
						>
							{showHours ? "Hours" : "Count"}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{Object.entries(data).length === 0 ? (
						<TableRow>
							<TableCell colSpan={2} align="center">
								No data
							</TableCell>
						</TableRow>
					) : (
						Object.entries(data).map(([key, count]) => (
							<TableRow key={key}>
								<TableCell
									onClick={(e) => handleNavigation(e, key)}
									sx={{ cursor: "pointer" }}
								>
									{key}
								</TableCell>
								<TableCell>{count}</TableCell>
							</TableRow>
						))
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
